import 'antd/lib/input-number/style';
//# sourceMappingURL=index.js.map